
import React, { useState } from 'react';

export default function RecuperarPassword() {
  const [email, setEmail] = useState('');
  const [ok, setOk] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async e => {
    e.preventDefault();
    setError('');
    setOk(false);
    setLoading(true);
    try {
      const res = await fetch('https://api.braineka.com/usuarios/recuperar-password', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email })
      });
      const data = await res.json().catch(() => ({}));
      if (!res.ok) throw new Error(data.detail || data.error || 'No se pudo enviar el correo.');
      setOk(true);
    } catch (err) {
      setError(err.message || 'No se pudo enviar el correo.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="recuperar-container">
      <form className="recuperar-form" onSubmit={handleSubmit}>
        <h3>Recuperar contraseña</h3>
        <input
          type="email"
          placeholder="Email registrado"
          value={email}
          onChange={e => setEmail(e.target.value)}
          required
        />
        <button type="submit" disabled={loading}>{loading ? 'Enviando...' : 'Enviar enlace'}</button>
        {ok && <div className="recuperar-ok">Si el email existe, recibirás instrucciones para restablecer tu contraseña.</div>}
        {error && <div className="recuperar-error">{error}</div>}
      </form>
    </div>
  );
}
